<template>
  <ul :class="[depth === 0 ? 'list02-list': 'list02']">
    <li v-for="list in table.lists"
      @click.stop="list.isOpen = !list.isOpen"
      :key="'list_' + list.category_id + list.guide_id"
      :class="{
        'list02-item': true,
        'is-parent': list.isCategory,
        'is-open': list.isOpen,
        'is-selected': guide.currentContentId && list.guide_id === guide.currentContentId
      }"
      ref="items">
      <div class="wrap">
        <div v-if="list.isCategory" class="label" role="button">
          <FontawesomeIcon v-if="list.isOpen" icon="minus" class="icn-before" />
          <FontawesomeIcon v-else icon="plus" class="icn-before" />
          <span class="main" v-html="list.name"></span>
        </div>
        <div v-else-if="list.isDetail" class="label" role="button">
          <router-link :to="'/pc/guide/' + list.guide_id" class="main txt-blue" v-html="list.name"></router-link>
        </div>
      </div>
      <PCGuideTableList v-if="list.hasChild" :lists="list.children" :depth="list.depth" @open="list.isOpen = true, $emit('open')" />
    </li>
  </ul>
</template>
<script>
import { defineComponent, reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import * as apiGuide from '@/api/guide'
import * as _ from 'lodash'
import PCGuideTableList from '@/components/pc/partial/guide/PCGuideTableList.vue'

export default defineComponent({
  props: {
    depth: {
      default: null
    },
    lists: {
      default: []
    }
  },
  name: 'PCGuideTableList',
  components: {
    PCGuideTableList
  },  
  setup (props, context) {
    const store = context.root.$store
    const router = context.root.$router
    const { guide } = store.state

    onBeforeMount(async () => {
    })

    const state = reactive({
    })

    const action = {
      // 目次クリックで移動
      router: (path) => {
        const { history: { current: { fullPath } } } = router
        if (path !== fullPath) {
          router.push({ path: path})
        }
      }
    }

    const table = reactive({
      lists: computed(() => props.lists),
      changeOpen: (categoryId) => {
        store.dispatch('guide/changeOpen', categoryId)
      }
    })

    watch(() => guide.currentContentId, (now, old) => {
      if (now) {
        const index = _.findIndex(table.lists, list => list.guide_id === now)
        if (index !== -1) {
          // 選択中のコンテンツが変わった際に、該当目次を開く
          context.root.$nextTick(() => {
            context.emit('open')
            // 目次を開いた後、スクロール位置を調整する
            context.root.$nextTick(() => {
              const top = context.refs.items[index].offsetTop
              store.dispatch('guide/scrollTo', top - 100)
            })
          })
        }
      }
    })

    return {
      state,
      table,
      action,
      guide
    }
  }
})
</script>

<style lang="scss" scoped>
#navi-content .list02 .list02-item {
  .wrap.wrap-top {
    padding: 10px 24px;
  }
}
#navi-content {
  overflow: auto;
  line-height: 1.2em;
  .list02 {
    margin-top: 0;
    overflow: auto;
    &-list {
      padding-bottom: 40px;
    }
    &-item {
      .wrap {
        padding-right: 24px;
        padding-left: 24px;
      }
      .button {
        right: 0;
        width: 48px;
        font-size: 1.4rem;
      }
      &.is-selected {
        background-color: $color-selected;
      }
      &:not(.is-parent) .wrap .label:before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background-color: #555555;
        border-radius: 2px;
        position: absolute;
        top: 6px;
        left: 4px;
      }
    }
    .wrap .label .icn-before {
      top: 2px;
    }
  }
}


</style>
